import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=4c6bb6af&"
import script from "./ProfileAbout.vue?vue&type=script&lang=js&"
export * from "./ProfileAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6bb6af')) {
      api.createRecord('4c6bb6af', component.options)
    } else {
      api.reload('4c6bb6af', component.options)
    }
    module.hot.accept("./ProfileAbout.vue?vue&type=template&id=4c6bb6af&", function () {
      api.rerender('4c6bb6af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfileAbout.vue"
export default component.exports